<section class="p-documentos-selecionar-tipo">
  <usucampeao-documentos-selecionar-tipo [documentosIdentidade]="documentosIdentidade" [documentosEstadoCivil]="documentosEstadoCivil"></usucampeao-documentos-selecionar-tipo>
</section>
